import { render, staticRenderFns } from "./warehouseDetail.vue?vue&type=template&id=8cd2392c&scoped=true&"
import script from "./warehouseDetail.vue?vue&type=script&lang=js&"
export * from "./warehouseDetail.vue?vue&type=script&lang=js&"
import style0 from "./warehouseDetail.vue?vue&type=style&index=0&id=8cd2392c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd2392c",
  null
  
)

export default component.exports